import {observable, action} from "mobx";
import Cookies from "js-cookie";
import * as api from "../services/api";
import { clearHubDataFromStorage } from "../services/hubs";

class UserStore {
    @observable authedUser = null;
    @observable loading = false;
    @observable message = '';
    @observable userPhone = null;
    @observable userId = null;
    
    @action login = async (data) => {
        this.loading = true;
        try {
            const res = await api.login(data);

            if (res.requires_otp) {
                if (!res.otp_sent) {
                    return { requiresOtp: true, error: true };
                }
                this.userPhone = res.phone_no;
                this.userId = res.user_id;
                return { requiresOtp: true, error: false };
            }

            Cookies.set('token', res.access_token, { 'expires': 30 });
            this.authedUser = res.access_token;
            return { requiresOtp: false, error: false };
        } catch (e) {
            this.message = e.message || 'Login failed';
            alert(this.message);
            return { requiresOtp: false, error: true };
        } finally {
            this.loading = false;
        }
    };

    @action verifyOtp = async (otp) => {
        this.loading = true;
        try {
            const res = await api.verifyOtp({
                otp,
                phone_no: this.userPhone,
                user_id: this.userId,
            });
            Cookies.set('token', res.access_token, { 'expires': 30 });
            this.authedUser = res.access_token;
            return true;
        } catch (e) {
            this.message = e.message || 'OTP verification failed';
            return false;
        } finally {
            this.loading = false;
        }
    };

    @action logout = () => {
        Cookies.remove('token');
        clearHubDataFromStorage();
        window.location.replace("/");
    };
}

const store = new UserStore()
export default store
